module.exports = __webpack_public_path__ + "static/img/sjcj_yellow.294cf54f.svg";